const items = [
  {
    title: "رؤيتنا",
    description:
      "أن نكون جهة موثوقة في تقديم حلول إعادة التدوير والمساهمة في بناء مستقبل أكثر استدامة.",
  },
  {
    title: "رسالتنا",
    description:
      "تقديم خدمات تدوير منظمة وفعالة تساعد على تقليل الهدر وتحويل المواد القابلة للاستفادة إلى موارد ذات قيمة.",
  },
];

export default function VisionMission() {
  return (
    <section className="bg-gray-50 py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-6 md:grid-cols-2">
          {items.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl border border-gray-200 bg-white p-8 transition duration-300 hover:-translate-y-1 hover:shadow-lg md:p-10"
            >
              <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-green-50 text-green-600">
                ✓
              </span>

              <h3 className="text-2xl font-bold text-gray-900">
                {item.title}
              </h3>

              <p className="mt-4 leading-8 text-gray-600">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}